import apiClient from './index';

export interface ExportJob {
  id: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  export_type: string;
  export_type_display: string;
  collection_count: number;
  error_summary: string | null;
  zip_filename: string | null;
  downloaded_at: string | null;
  created_at: string;
  completed_at: string | null;
}

export function isExportJobActive(job: ExportJob): boolean {
  return job.status === 'pending' || job.status === 'processing';
}

export function isExportJobTerminal(job: ExportJob): boolean {
  return job.status === 'completed' || job.status === 'failed';
}

export function isExportJobReadyToDownload(job: ExportJob): boolean {
  return (
    job.status === 'completed' &&
    job.zip_filename != null &&
    job.downloaded_at == null
  );
}

export interface ExportJobListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: ExportJob[];
}

interface FetchExportJobsParams {
  page?: number;
  pageSize?: number;
  activeOnly?: boolean;
}

export async function fetchExportJobs({
  page = 1,
  pageSize = 25,
  activeOnly = false,
}: FetchExportJobsParams = {}): Promise<ExportJobListResponse> {
  const params: Record<string, string | number> = {
    page,
    page_size: pageSize,
  };
  if (activeOnly) {
    params.active_only = '1';
  }
  const { data } = await apiClient.get('/sigcap/api/export-jobs/', { params });
  return data;
}
